<style lang="scss" scoped>
    .print-link {
        font-size: 1.2em;
    }
</style>

<template>
    <div>
        <div v-if="trainingSession.is_finalized">
            <template v-if="hasCertificateLinks">
                <h4>Print Certificate</h4>
                <template v-for="(name, idx) in participantNames">
                    <div>
                        <button type="button" class='print-link btn btn-link' @click="print(idx)">{{ name }}</button>
                    </div>
                </template>
            </template>
            <template v-else>
                <h3>{{ trainingSession.title }}</h3>
                <p><strong>Number of Participants</strong>: {{ trainingSession.participant_count }}</p>
                <p><strong>Started</strong>: {{ startedDate }}</p>
                <p><strong>Completed</strong>: {{ finalizedDate }}</p>
            </template>
        </div>

        <div v-else>
            <div class='m-3'>
                You must watch the training video, successfully pass the quiz, and complete your evaluation before printing your certificate.
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex';

    export default{
        components: {
        },
        props: {
        },
        data() {
            return {
            }
        },
        methods: {
            print(idx) {
                window.open(this.$basePath+'/training-session/' + this.trainingSession.id + '/certificate/' + idx, '_blank');
            }
        },
        computed: {
            participantNames: function() {
                if(this.trainingSession) {
                    return this.sessionParticipants[this.trainingSessionId].map(p => p.first_name + " " + p.last_name);
                }
                return [];
            },
            trainingSession() {
                return this.trainingSessions[this.trainingSessionId];
            },
            trainingSessionId() {
                return this.currentTrainingSession;
            },
            startedDate() {
                return moment(this.trainingSession.start_time).format("LL LT");
            },
            finalizedDate() {
                return moment(this.trainingSession.finalized_at).format("LL LT");
            },
            hasCertificateLinks() {
                return this.participantNames.length > 0;
            },
            ...mapState([
                'trainingSessions',
                'sessionParticipants',
                'currentTrainingSession',
            ]),
        },
        mounted() {
        }
    }
</script>
